/**
 * Configuration for Pinpoint Web App
 *
 * DEV_MODE is automatically true when running `npm run dev` (Vite dev server)
 * and false when built for production (`npm run build`).
 */

const DEV_MODE = import.meta.env.DEV;

// Cloudflare Worker API URLs
const API_URLS = {
  production: 'https://canlii-pinpoint-api.thomoal.workers.dev',
  dev: 'https://canlii-pinpoint-api-dev.thomoal.workers.dev',
};

export const API_URL = DEV_MODE ? API_URLS.dev : API_URLS.production;
